export default "__VITE_ASSET__64232731__"